import script from "./ui-select-autocomplete.vue?vue&type=script&lang=ts&setup=true"
export * from "./ui-select-autocomplete.vue?vue&type=script&lang=ts&setup=true"

import "./ui-select-autocomplete.vue?vue&type=style&index=0&id=2d647a78&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d647a78"]])

export default __exports__